import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

type CommunitySearchBarProps = {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly placeholder?: string;
  readonly loading?: boolean;
};

export function CommunitySearchBar({
  value,
  onChange,
  placeholder = "Search lessons and courses…",
  loading,
}: CommunitySearchBarProps) {
  const [local, setLocal] = useState(value);

  useEffect(() => {
    setLocal(value);
  }, [value]);

  useEffect(() => {
    const t = window.setTimeout(() => {
      if (local !== value) onChange(local);
    }, 300);
    return () => window.clearTimeout(t);
  }, [local, onChange, value]);

  return (
    <label className="teacher-library-search field">
      <span className="field-label">Search</span>
      <span className="teacher-library-search-wrap">
        <FontAwesomeIcon icon={faMagnifyingGlass} className="teacher-library-search-icon" />
        <input
          className="input teacher-library-search-input"
          type="search"
          value={local}
          placeholder={placeholder}
          onChange={(ev) => setLocal(ev.target.value)}
          aria-busy={loading || undefined}
        />
      </span>
    </label>
  );
}
